'use client'

import React from 'react'

type Props = {
    base: number
    triangleHeight: number
    length: number
}

const WIDTH = 340
const HEIGHT = 220

export default function TriangularPrismChart({ base, triangleHeight, length }: Props) {
    const maxDim = Math.max(base, triangleHeight, length, 0.0001)
    const scale = 120 / maxDim
    const b = Math.max(base * scale, 50)
    const th = Math.max(triangleHeight * scale, 50)
    const depth = Math.max(length * scale, 40)
    const ox = depth * 0.7
    const oy = -depth * 0.35

    const fx = (WIDTH - b - ox) / 2
    const fy = (HEIGHT + th - oy) / 2 - 15

    const A = [fx, fy] // front bottom-left (right angle corner)
    const Bp = [fx + b, fy] // front bottom-right
    const Cp = [fx, fy - th] // front top (apex above A)
    const A2 = [fx + ox, fy + oy]
    const B2 = [fx + b + ox, fy + oy]
    const C2 = [fx + ox, fy - th + oy]

    const pts = (arr: number[][]) => arr.map((p) => p.join(',')).join(' ')

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* hidden back triangle + connecting edge */}
            <polygon points={pts([A2, B2, C2])} fill="none" stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={A[0]} y1={A[1]} x2={A2[0]} y2={A2[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            {/* top face */}
            <polygon points={pts([Cp, C2, B2, Bp])} fill="#2563eb" opacity={0.16} stroke="#2563eb" strokeWidth={2} />
            {/* bottom face */}
            <polygon points={pts([A, Bp, B2, A2])} fill="#2563eb" opacity={0.1} stroke="#2563eb" strokeWidth={1.5} />
            {/* front triangle */}
            <polygon points={pts([A, Bp, Cp])} fill="#2563eb" opacity={0.3} stroke="#2563eb" strokeWidth={2} />
            {/* connecting edges */}
            <line x1={Bp[0]} y1={Bp[1]} x2={B2[0]} y2={B2[1]} stroke="#2563eb" strokeWidth={2} />
            <line x1={Cp[0]} y1={Cp[1]} x2={C2[0]} y2={C2[1]} stroke="#2563eb" strokeWidth={2} />

            <text x={(A[0] + Bp[0]) / 2} y={A[1] + 20} fontSize={11} textAnchor="middle" fill="#374151">base = {base.toFixed(2)}</text>
            <text x={A[0] - 8} y={(A[1] + Cp[1]) / 2} fontSize={11} textAnchor="end" fill="#374151">h = {triangleHeight.toFixed(2)}</text>
            <text x={(Bp[0] + B2[0]) / 2 + 6} y={(Bp[1] + B2[1]) / 2 - 4} fontSize={11} fill="#374151">len = {length.toFixed(2)}</text>
        </svg>
    )
}
